<div class="container">
  @if (showTitle) {
    <div class="title">
      {{ progress | percent: "1.0" }}
    </div>
  }
  <div class="status">
    <div
      class="progress"
      [ngClass]="styleClass"
      [style.backgroundColor]="color"
      [style.width.%]="progress > 1 ? 100 : progress * 100"></div>
  </div>
</div>
